<!--Supplementary items-->
<template>
    <label class="sr-only" for="supplementaryItems" id="supplementaryLabelSr">{{getInterfaceText('supplementaryitems')}}</label>
    <label class="hidden" id="supplementaryValueSr" v-if="supplementaryItem.length > 0">{{supplementaryItem.description}}</label>
    <label class="hidden" id="supplementaryValueSr" v-if="partnumber != null && partnumber.supplementaryGroup != null">{{partnumber.supplementaryGroup.label}}</label>
    <p class="subheading">
        <span class="headinglabel" v-if="partnumber != null && partnumber.supplementaryGroup != null">{{partnumber.supplementaryGroup.label}}</span>
        <span class="headingvalue" v-show="supplementaryItem != null && supplementaryItem.code != null"> - <strong>{{supplementaryItem.description}}</strong></span>
    </p>
    <div class="supplementaryItems sizes clearfix" v-if="partnumber != null && partnumber.supplementaryGroup != null">
        <p for="supplementaryItems" style="font-size:13px;">{{partnumber.supplementaryGroup.introText}}<span v-show="partnumber.supplementaryGroup.url != null">&nbsp;<a class="fancybox fancybox.iframe" data-fancybox data-type="iframe" data-src="{{partnumber.supplementaryGroup.url != null ? partnumber.supplementaryGroup.url + '?frame=popup' : ''}}">{{partnumber.supplementaryGroup.urlLabel}} <i class="glyphicon glyphicon-new-window" aria-hidden="true"></i></a></span></p>
        <template v-for="item in partnumber.supplementaryGroup.items" :key="item.code">
            <button class="name-and-stockinfo size" :class="(item == supplementaryItem ? 'size-selected ' : '') + (supplementaryItem != null && supplementaryItem.stock != null && supplementaryItem.stock.Code == 0 && item != supplementaryItem ? ' disabled' : '')" :id="supplementaryItem.code" v-on:click="selectSupplementaryItem(item)" :disabled="supplementaryItem != null && supplementaryItem.stock != null && supplementaryItem.stock.Code == 0 && item != supplementaryItem">
                <div class="name">{{item.description}} + {{item.priceToFormat}}</div>
            </button>
        </template>
    </div>
</template>
<script>
    import generalMixin from '../mixins/general.js';
    import vueStore from '../store/store.js';
    export default {
        name: 'SupplementaryItems',
        mixins: [generalMixin],
        data: function () {
            return {
                selectedBundle: '',
                showAddedLabel: false,
                exceptionMessageBundleItem: ''
            }
        },
        methods: {
            selectSupplementaryItem(supplementaryItem) {
                if (this.supplementaryItem == supplementaryItem) {
                    supplementaryItem = {};
                } else {
                    // SK add ga4 tracking
                    window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_supplementary', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': supplementaryItem.description });
                }
                vueStore.commit('setSupplementaryItem', supplementaryItem);
            },
        },
        computed: {
            partnumber() {
                return vueStore.state.partnumber
            },
            supplementaryItem: {
                get() {
                    return vueStore.state.supplementaryItem
                },
                set(value) {
                    vueStore.commit('setSupplementaryItem', value)
                }
            },
            product() {
                return vueStore.state.product
            },
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
        }
    }
</script>
